import firebase from 'firebase';

import store from '@/store';
import { SET_AUTH, SET_USER, CLEAR_POSTS } from '@/store/mutationTypes';

import { watchUser } from './repositories/users';

let watchUserUnsubscriber;

export function init() {
  firebase.auth().onAuthStateChanged((auth) => {
    store.commit(SET_USER, null);
    store.commit(SET_AUTH, auth);
    store.commit(CLEAR_POSTS);

    if (watchUserUnsubscriber) {
      watchUserUnsubscriber();
    }

    if (auth && auth.uid) {
      watchUserUnsubscriber = watchUser(auth.uid, (user) => {
        store.commit(SET_USER, user);
      });
    }
  });
}

export function stop() {
  if (watchUserUnsubscriber) {
    watchUserUnsubscriber();
  }
}



// WEBPACK FOOTER //
// ./src/firebase/watcher.js